module.exports = __webpack_public_path__ + "static/img/h10-2.e54ce0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h10-2.png
// module id = eA7R
// module chunks = 1